<template>
    <bottom-dialog v-model="e.show" max-width="550px" scrollable :dialog="true || !$vuetify.breakpoint.mobile" v-if="e.show">
        <v-card tile elevation="0">
            <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text">
                <div class="font-weight-bold fill-width">
                    {{user && user.name}}
                    <v-btn icon @click="e.show = false" class="float-right"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                </div>
            </v-card-title>
            <v-card-text>
                <v-checkbox
                    v-for="p in permissions"
                    :key="p.id"
                    :label="p.title"
                    v-model="permissionValues[p.id]"
                    :disabled="p.disabled"
                />

                <v-progress-circular v-if="fullUserLoading"
                                     indeterminate
                                     color="primary"
                ></v-progress-circular>

                <account v-else-if="initialPermissionValues.manage" :user="fullUser" :debounce-emit="false" @input="userChanged"/>
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" block class="zoezi-button-thin" @click="changeUser" :loading="saving" :disabled="!valuesChanged">{{$translate(saveTitle)}}</v-btn>
            </v-card-actions>
        </v-card>
    </bottom-dialog>
</template>

<script>
import BottomDialog from '../components/BottomDialog.vue'
import Account from './Account.vue';
import {isEqual} from 'lodash';
export default {
    name: 'zoezi-change-user-dialog',

    components: {
        BottomDialog,
        Account
    },

    watch: {
        'e.show': {
            immediate: true,
            handler(show) {
                if (show) {
                    Object.assign(this.permissionValues, this.initialPermissionValues);

                    this.changedUserData = null;
                    this.loadUser();
                }
            }
        },
        '$store.state.user'() {
            if (this.e.show && this.user_id) {
                this.loadUser();
            }
        }
    },

    data: () => ({
        fullUser: null,
        changeUserFormValid: false,
        fullUserLoading: false,
        permissionValues: {
            book: false,
            book_me: false,
            manage: false,
            manage_me: false,
            pay: false
        },
        changedUserData: null,
        saving: false
    }),

    computed: {
        e() {
            return this.$store.state.changeUserDialog;
        },
        user_id() {
            return this.e.user_id;
        },
        firstname() {
            let user = this.user;
            let name = user.name.split(' ')[0];
            return name;
        },
        firstnames() {
            let name = this.firstname;
            let names = ['s', 'x', 'z'].includes(name[name.length-1]) ? name : name + 's';
            return names;
        },
        user() {
            let me = this.$store.state.user;
            let user_id = this.user_id;
            return me.canBookFor.find(x => x.id == user_id) ||
                me.bookers.find(x => x.id == user_id) ||
                me.canManage.find(x => x.id == user_id) ||
                me.managers.find(x => x.id == user_id) ||
                me.paysFor.find(x => x.id == user_id);
        },
        initialPermissionValues() {
            let me = this.$store.state.user;
            let user_id = this.user_id;
            return {
                book: me.canBookFor.some(x => x.id == user_id),
                book_me: me.bookers.some(x => x.id == user_id),
                manage: me.canManage.some(x => x.id == user_id),
                manage_me: me.managers.some(x => x.id == user_id),
                pay: me.paysFor.find(x => x.id == user_id)
            };
        },
        permissions() {
            if (!this.user) {
                return [];
            }

            let name = this.firstname;
            let names = this.firstnames;

            return [
                {title: this.$translate('{0} can book for you').format(name), id: 'book_me'},
                {title: this.bookRequested ? this.$translate('You have applied to book for {0}').format(name) : this.$translate('You can book for {0}').format(name), id: 'book', disabled: this.bookRequested},
                {title: this.$translate('{0} manages your account').format(name), id: 'manage_me'},
                {title: this.manageRequested ? this.$translate('You have applied to manage {0} account').format(names) : this.$translate('You can manage {0} account').format(names), id: 'manage', disabled: this.manageRequested},
                {title: this.$translate('You pay for {0}').format(name), id: 'pay'}
            ];
        },
        valuesChanged() {
            return !!this.changedUserData || !isEqual(this.initialPermissionValues, this.permissionValues);
        },
        bookRequested() {
            let me = this.$store.state.user;
            return !!me.requestssent.find(x => x.user.id == this.user.id && x.book);
        },
        manageRequested() {
            let me = this.$store.state.user;
            return !!me.requestssent.find(x => x.user.id == this.user.id && x.manage);
        },
        submitData() {
            let data = Object.assign({}, this.changedUserData);
            data.id = this.user.id;

            ['book', 'book_me', 'manage', 'manage_me', 'pay'].forEach(key => {
                if (this.initialPermissionValues[key] != this.permissionValues[key] && !this.permissions.find(x => x.id == key).disabled) {
                    data[key] = this.permissionValues[key];
                }
            })

            return data;
        },
        saveTitle() {
            if (this.submitData.book || this.submitData.manage) {
                if (!this.initialPermissionValues.manage) {
                    return this.changedUserData ? 'Save and apply' : 'Apply';
                }
            }

            return 'Save';
        }
    },

    methods: {
        userChanged(data) {
            this.changedUserData = data;
        },
        changeUser() {
            this.saving = true;
            this.$api.post('/api/memberapi/change', this.submitData).then(() => {
                this.changedUserData = null;
                this.saving = false;
                this.e.show = false;
            })
        },
        loadUser() {
            this.fullUser = null;
            if (this.permissionValues.manage) {
                this.fullUserLoading = true;
                this.$api.get('/api/memberapi/child/get', {id: this.user_id}).then(user => {
                    this.fullUser = user
                    this.fullUserLoading = false;
                }).catch(() => {
                    this.fullUserLoading = false;
                });
            }
        }
    }
}
</script>
